const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.928,8.572A3.975,3.975,0,1,1,15.954,4.6,3.974,3.974,0,0,1,19.928,8.572Zm2.53,0a6.5,6.5,0,1,1-6.5-6.5A6.5,6.5,0,0,1,22.458,8.572ZM12.36,18.09h-.027l-.062.013h0l-.08.017c-.131.027-.331.076-.577.152a7.323,7.323,0,0,0-1.844.848,8.075,8.075,0,0,0-3.5,5.736v2.805H25.729v-2.8a8.075,8.075,0,0,0-3.5-5.736,7.323,7.323,0,0,0-1.844-.848c-.246-.076-.446-.125-.577-.152l-.081-.017-.061-.013H19.64a1.215,1.215,0,0,1-1.152-1.484c.2-.707.758-.861,1.489-.769l-.165,1.323c.165-1.323.168-1.323.168-1.323h0l.009,0,.025,0,.075.012c.062.01.146.024.248.045.2.042.488.109.825.212a10.1,10.1,0,0,1,2.513,1.167A9.616,9.616,0,0,1,28,24.633l.008.073v3.36a1.867,1.867,0,0,1-1.867,1.867H5.864A1.867,1.867,0,0,1,4,28.066v-3.36l.008-.073a9.616,9.616,0,0,1,4.316-7.355,10.107,10.107,0,0,1,2.512-1.167c.338-.1.621-.17.826-.212.1-.021.186-.035.248-.045l.075-.012.025,0,.009,0h0s0,0,.168,1.323l-.165-1.323c.731-.092,1.285.062,1.489.769A1.215,1.215,0,0,1,12.36,18.09Z",
    style: {
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.f54e82abe1179c27b7aa28a7e27308f3.svg";
export { ForwardRef as ReactComponent };